const MONEY_KEYS = new Set([
  'totalRevenue',
  'averageOrderValue',
  'selectedTotalRevenue',
  'previousTotalRevenue',
  'absoluteChange',
  'previous',
  'selected',
  'currentRevenue',
  'previousRevenue',
]);

function toNumericAmount(value) {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return null;
}

function convertValue(value, rate) {
  const amount = toNumericAmount(value);
  if (amount == null) return value;
  return amount * rate;
}

export function hasExchangeRate(rates, currency, sourceCurrency = 'DKK') {
  if (!currency || currency === sourceCurrency) return true;
  const rate = rates?.[currency];
  return typeof rate === 'number' && Number.isFinite(rate) && rate > 0;
}

function walk(node, rate) {
  if (node == null) return node;
  if (Array.isArray(node)) return node.map((item) => walk(item, rate));
  if (typeof node !== 'object') return node;

  const out = {};
  for (const [key, value] of Object.entries(node)) {
    if (MONEY_KEYS.has(key)) {
      const isNestedMoneyObject =
        value != null && typeof value === 'object' && !Array.isArray(value);
      out[key] = isNestedMoneyObject ? walk(value, rate) : convertValue(value, rate);
    } else {
      out[key] = walk(value, rate);
    }
  }
  return out;
}

export function convertDashboardData(data, displayCurrency, rates, sourceCurrency = 'DKK') {
  if (!data || displayCurrency === sourceCurrency) return data;

  const rate = rates?.[displayCurrency];
  if (!hasExchangeRate(rates, displayCurrency, sourceCurrency)) return data;

  const converted = walk(data, rate);
  if (converted.summary) {
    converted.summary = {
      ...converted.summary,
      currencyCode: displayCurrency,
    };
  }

  return converted;
}

export function convertMoneyRows(rows, displayCurrency, rates, sourceCurrency = 'DKK') {
  if (!rows?.length || displayCurrency === sourceCurrency) return rows;

  if (!hasExchangeRate(rates, displayCurrency, sourceCurrency)) return rows;

  const rate = rates[displayCurrency];

  return rows.map((row) => ({
    ...row,
    totalRevenue: convertValue(row.totalRevenue, rate),
  }));
}
